<template>
  <div id="app" style="background-color: #DFE0E2 !important">
    <!-- Navigation -->
    <b-navbar toggleable="md" class="sf-navbar" fixed="top">
      <b-navbar-toggle target="nav_collapse"/>
      <b-navbar-brand to="/" class="sf-navbar">
        <b-img src="/static/thebrainlogo.png" class="navbar-img-logo"/>
      </b-navbar-brand>
      <b-collapse is-nav id="nav_collapse" class="pl-3">
        <b-navbar-nav>
          <b-navbar-brand to="/scoring-events" class="sf-navbar">
            <b-img src="/static/Grow.png" class="navbar-img"/>
            <br>
            Scoring Events
          </b-navbar-brand>
          <b-navbar-brand to="/wizard" class="sf-navbar">
            <b-img src="/static/Ruler.png" class="navbar-img"/>
            <br>
            Import Survey Data
          </b-navbar-brand>
          <b-navbar-brand to="/new-scoring-event" class="sf-navbar">
            <b-img src="/static/Ask.png" class="navbar-img"/>
            <br
            >Add Scoring Event
          </b-navbar-brand>
          <b-navbar-brand to="/quick-win-recommendation-search" class="sf-navbar">
            <b-img src="/static/Hammer.png" class="navbar-img"/>
            <br>
            Quick Wins
          </b-navbar-brand>
          <b-navbar-brand to="/quick-win-recommendation-search?type=recommendations" class="sf-navbar">
            <b-img src="/static/Screwdriver.png" class="navbar-img"/>
            <br>
            Recommendations
          </b-navbar-brand>
          <b-navbar-brand to="/gpc-sessions" class="sf-navbar">
            <b-img src="/static/Spanner.png" class="navbar-img"/>
            <br>
            GPC Sessions
          </b-navbar-brand>
          <b-navbar-brand to="/smart-goals" class="sf-navbar">
            <b-img src="/static/pliers.png" class="navbar-img"/>
            <br>
            SMART Goals
          </b-navbar-brand>
          <b-navbar-brand to="/industry-data" class="sf-navbar">
            <b-img src="/static/Think.png" class="navbar-img"/>
            <br>
            Industry Data
          </b-navbar-brand>
        </b-navbar-nav>
      </b-collapse>
      

        
    </b-navbar>
    <!-- Page Content -->
    <br>
    <b-container class="mt-4 pt-2 pb-2 pl-2 pr-2">
      <b-row class="text-center" align-h="center">
        <a v-if="!$root.surveyMonkeyCode && !$root.token" :href="$root.SURVEY_MONKEY_URL" class='btn btn-primary surveymonkey mt-2 mb-2'>Survey Monkey Sign-In</a>
        <div id="g_id_onload"
             v-show="$root.surveyMonkeyCode && !$root.token && !loggingIn"
             :data-client_id="googleClientId"
             data-context="signin"
             data-ux_mode="popup"
             data-callback="handleGoogleResponse"
             data-auto_prompt="false"/>

        <div class="g_id_signin"
             v-show="$root.surveyMonkeyCode && !$root.token && !loggingIn"
             data-type="standard"
             data-shape="pill"
             data-theme="outline"
             data-text="signin_with"
             data-size="large"
             data-logo_alignment="left"/>
        <div v-if="loggingIn"><font-awesome-icon icon="spinner" size="lg" spin class="mt-2 mb-2"/> Logging in....</div>
        <router-view/>
      </b-row>
      <b-row style="height: 200px">
        <b-img class="pl-2 pr-2 pb-2 auto-img" src="/static/squiggle-large.jpg"/>
      </b-row>
    </b-container>
    <br>
    
  </div>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
      googleClientId: process.env.GOOGLE_CLIENT_ID,
      loggingIn: false
    }
  },
  created: function() {
    if (this.$route.query.code) {
      this.$root.surveyMonkeyCode = this.$route.query.code;
    }
    var that = this;
    window.handleGoogleResponse = function(response) {
      if (response.credential) {
        that.$root.googleCode = response.credential;
        if (that.$root.surveyMonkeyCode && that.$root.googleCode) {
          that.loggingIn = true;
          that.$http.post(`${that.$root.API_ENDPOINT}authenticate`, { googleToken: that.$root.googleCode, surveyMonkeyToken: that.$root.surveyMonkeyCode }).then(function (response) {
            that.$root.token = response.body.token;
            console.log('Logged in');
            that.loggingIn = false;
          }).catch(function (error) {
            that.$root.surveyMonkeyCode = null;
            that.$root.token = null;
            that.$root.googleCode = null;
          });
        }
      }
    } 
  }
}
    
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.g-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  background-color: #3c82f7;
  color: #fff;
  box-shadow: 0 3px 0 #0f69ff;
}

/* little red asterick indicator */
label.required:after { 
  content:" *";
  color:red;
}

div.required:after {
  content: " *";
  color: red;
}

/* style the select dropdown */
/* this hides the doubled up arrows on the select elements 
   may cause issues in chrome
*/
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';
}

/* This ensures an invalid option in the select is gray as well - must have required field on select */
select.form-control.custom-select:invalid,
select.form-control.custom-select option[value=""]:first-child {
  color: gray;
  font-style: italic;
}

select.form-control.custom-select option:not(:first-child) {
  color: black;
  font-style: normal;
}

tr.c > td {
  vertical-align: middle;
}

.fa-file-download:hover {
    color: #dc3545;
}

.clickable {
  cursor: pointer;
}

.clickable > * {
  cursor: pointer;
}

.pad-top-1 {
  margin-top: 1em;
}

/* Chrome/Opera/Safari */
::-webkit-input-placeholder { 
  color: gray;
  font-style: italic;
}
/* Firefox 19+ */
::-moz-placeholder { 
  color: gray;
  font-style: italic;
}
/* IE 10+ */
:-ms-input-placeholder {
  color: gray;
  font-style: italic;
}
/* Firefox 18- */
:-moz-placeholder {
  color: gray;
  font-style: italic;
}

.btn-primary.surveymonkey {
  background-color: #00BF6F !important;
  border-color: #00BF6F !important;
}

.centergooglebutton {
  text-align: center;
  display: inline-block;
}

.container {
  background-color: #FFFFFF !important;
}

.auto-img {
  min-width: 100% !important;
  max-width: 100% !important;
  display: block;
  object-fit: contain;
}

.sf-navbar {
  background-color: #5F6062;
  color: #FFFFFF !important;
}

.navbar-img {
  height: 30px;
}

.navbar-img-logo {
  height: 50px;
}



</style>
<style lang="scss">
@import '../node_modules/bootstrap/scss/bootstrap.scss';
</style>
<style lang="css">
@import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
</style>



// WEBPACK FOOTER //
// src/App.vue